import {Component} from '@angular/core';
import {NavController, NavParams, ModalController} from 'ionic-angular';
import * as Highcharts from 'highcharts';
import * as _ from 'lodash';
import * as moment from 'moment';

import {Data} from '../../providers/providers';
import {Location} from '../../models/location';
import {Irrigation} from '../../providers/providers';
import {AboutIrrigationPage} from "../about-irrigation/about-irrigation";
import {LocationIrrigationRecordListPage} from "../location-irrigation-record-list/location-irrigation-record-list";

@Component({
  selector: 'page-location-irrigation',
  templateUrl: 'location-irrigation.html'
})
export class LocationIrrigationPage {

  location: Location;
  Highcharts = Highcharts;

  public showColumns: any[];

  constructor(public navCtrl: NavController,
              public modalCtrl: ModalController,
              public navParams: NavParams,
              public data: Data,
              public irrigation: Irrigation) {
    this.location = this.navParams.get('location');

    // initialize service
    this.irrigation.setLocation(this.location);

    this.showColumns = [
      'date',
      // 'water_balance_daily',
      'water_balance_cumulative',
      // 'orchard_et_gpa',
      // 'orchard_et_cumulative',
      // 'rainfall_in',
      'rainfall_gpa',
      // 'rainfall_cumulative',
      'irrigation',
      // 'irrigation_cumulative',
      // 'irrigation_time'
        'irrigation_recommendation'
    ];
  }

  columnSelected(cols) {
    return _.some(this.showColumns, (col) => _.indexOf(cols, col) != -1);
  }

  howManyColumnsSelected(cols) {
    let val = 0;
    for (let col of this.showColumns) {
      if (_.indexOf(cols, col) != -1) {
        val += 1;
      }
    }
    return val;
  }

  ngAfterViewInit() {
    this.irrigation.fetchResults();
  }

  endDateChanged() {
    this.irrigation.fetchResults();
  }

  public recalculate() {
      this.irrigation.fetchResults();
  }

  public debouncedRowRainfallChanged = _.debounce((row) => {
      if (row.rainfall_in) {
        row.rainfall_edited = true;
      }
    },
    1000
  );

  public debouncedRowIrrigationChanged = _.debounce((row) => {
      if (row.irrigation) {
        row.irrigation_edited = true;
      }
    },
    1000
  );

  rowIsForEndDate(row) {
    return moment(row.date).format('M/D/YYYY') == moment(this.irrigation.endDate).format('M/D/YYYY');
  }

  openAbout() {
    this.navCtrl.push(AboutIrrigationPage, {});
  }

  goToRecords() {
    this.navCtrl.pop();
    this.navCtrl.push(LocationIrrigationRecordListPage, {location: this.location});
  }
}



// WEBPACK FOOTER //
// ./src/pages/location-irrigation/location-irrigation.ts